import { DataBean } from "../DataBean";

export class TransportGuideItem extends DataBean {



    public async deleteTransportGuideItem(transportGuideDate: any, idTransportGuideItem: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteTransportGuideItem_java.util.Date_Number", [transportGuideDate, idTransportGuideItem]);
    }

    public async getTransportGuideItemCatalog(idTransportGuide: any, transportGuideDate: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getTransportGuideItemCatalog_Number_java.util.Date_Number_Number", [idTransportGuide, transportGuideDate, page, recordsPerPage]);
    }

    public async addTransportGuideItemList(idTransportGuide: number, transportGuideDate: number, itemList: any[], idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_addTransportGuideItemList_Number_java.util.Date_java.util.List_Number", [idTransportGuide, transportGuideDate, itemList, idEmployee]);
    }

}